import axios from "axios";
import { API_URL } from "./index";

export default
    {
        GetBolParaCompanies(token) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/get-bol-para-companies`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    onlyHasCampaigns: true
                }
            });
        },
        GetBolParaCompanyCampaigns(token, companyID) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/get-bolpara-campaigns`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    companyID: companyID
                }
            });
        },

        GetBolParaCampaign(token, campaignID) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/get-bolpara-campaign`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    campaignID: campaignID
                }
            });
        },
        GetBolParaResponses(token, poiID) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/get-bol-para-responses`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    poiID: poiID
                }
            });
        },

        BolParaAboutToken(token) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/about-token`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },

            });
        },
        GetBolParaAgreement(
            token,
            campaignID,
        ) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/get-bol-para-agreements`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    campaignID: campaignID,
                },
            });
        },
        GetBolParaCompanyHasCoupon(
            token,
            companyID,
        ) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/bol-para-has-coupon`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    companyID
                },
            });
        },

        GetBolParaCampaignHasCoupon(
            token,
            campaignID,
        ) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/bol-para-has-coupon`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    campaignID
                },
            });
        },

        GetNewCompanyCoupon(
            token,
            companyID,
            poiID
        ) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/bol-para-get-new-coupon`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    companyID,
                    viewedType: "esnaf",
                    poiID
                },
            });
        },
        GetNewCampaignCoupon(
            token,
            companyID,
            campaignID,
            poiID
        ) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/bol-para-get-new-coupon`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    companyID,
                    campaignID,
                    viewedType: "esnaf",
                    poiID
                },
            });
        },

        CreateBolParaQRShowLog(token, campaignID, poiID) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/create-bol-para-qr-show-log`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    campaignID,
                    poiID
                },
            });
        },
        AddAnalyticsTracking(token,sessionID, trackingKey, trackingValue, action) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/add-analytics-tracking`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    sessionID : sessionID,
                    trackingKey : trackingKey,
                    trackingValue : trackingValue,
                    action : action,
                },
            });
        },
    }